// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2T4A5___Layout-module__wrapper"};